var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SubAPI } from "./SubAPI";
export class Print extends SubAPI {
    print(input) { return this.fetcher.postFormData("/api/printing/print", input); }
    getStatus(input) { return this.fetcher.get("/api/printing/status", input); }
    download(input) { const c = new URLSearchParams(); c.set("uuid", input.uuid); window.open("/api/printing/download?" + c.toString(), "_blank"); }
    fileAsImage(input) {
        return __awaiter(this, void 0, void 0, function* () { const result = yield this.fetcher.get("/api/printing/file-to-image", input); const blob = yield result.blob(); return new Promise((resolve, reject) => { const fr = new FileReader(); fr.onload = () => { resolve(fr.result); }; fr.onerror = () => { reject(fr.error); }; fr.readAsDataURL(blob); }); });
    }
}
